<template>
  <v-layout row justify-center>
    <v-dialog v-model="sendDialog" persistent max-width="600px">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>Envoi des bulletins</v-card-title>
        <v-card-text>Attention : un mail contenant le bulletin en pièce jointe sera envoyé à tous les étudiants dont le bulletin n'a pas encore été envoyé. Assurez-vous donc que les bulletins ont bien été contrôllés.
          <v-divider class="mt-3"></v-divider>
          <v-radio-group v-model="mailingType" row>
            <v-radio label="Envoyer à tous" value="all"></v-radio>
            <v-radio label="Envoi par classe" value="filtered"></v-radio>
          </v-radio-group>
          <div v-if="mailingType === 'filtered'">
            <v-divider class="mb-3"></v-divider>
            <v-select
              label="Selectionner une classe..."
              :items="classes"
              v-model="selectedClass"
              solo
            ></v-select>
          </div>
          <div v-if="mailingType === 'filtered' && selectedClass">
            <v-divider class="mb-3"></v-divider>
            <v-checkbox
              v-for="student in selectedStudents"
              :key="student._id"
              :value="student._id"
              :label="`${student.firstName} ${student.lastName}`"
              v-model="filteredMailingList"
            ></v-checkbox>
          </div>
        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="toggleDialog" :disabled="updating">Annuler</v-btn>
          <v-btn
            color="blue darken-1"
            flat
            @click.prevent="sendEmails(mailingType === 'all' ? mailingList : filteredMailingList)"
            :disabled="updating"
          >Envoyer les bulletins</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  data: () => ({
    filteredMailingList: [],
    mailingType: "all",
    selectedClass: undefined
  }),
  props: ["sendDialog", "sendEmails", "toggleDialog", "updating", "students"],
  watch: {
    selectedStudents: function() {
      this.filteredMailingList = this.selectedStudents.map(s => s._id);
    },
    sendDialog: function(newVal) {
      if (newVal) {
        this.mailingType = "all";
      }
    }
  },
  computed: {
    mailingList: function() {
      return this.students.map(s => s._id);
    },
    classes: function() {
      return [...new Set(this.students.map(s => s.class))]
        .filter(s => s)
        .sort((a, b) => a.localeCompare(b));
    },
    selectedStudents: function() {
      return this.students.filter(
        s => s.class === this.selectedClass && !s.sentAt
      );
    }
  }
};
</script>

